import React from 'react';
import { Alert } from '~/ui/components';
import useDownloadFile from '~/hooks/useDownloadFile';
import { message } from 'antd';
import { remoteValues } from '~/common/utils/firebase/remoteConfig';
import { useModal } from '~/hooks/useModal';
import { PreviewModal } from '~/components';
import { FilesListContainer, EmptyList } from './FilesList.styled';
import FileSingle, { FileProps } from './FileSingle';

export interface FilesListProps {
  files: FileProps[];
  emptyMessage?: string;
  onFileClick?: (file: FileProps) => void;
  onFileDownload?: (file: FileProps) => void;
  loading?: boolean;
}

export function FilesList({
  files,
  loading,
  emptyMessage = 'Nenhum arquivo encontrado',
  onFileClick,
  onFileDownload,
}: FilesListProps) {
  const download = useDownloadFile();
  const { openModal } = useModal();

  const { enableForceDownload } = remoteValues;

  const handleFileClick = (file: FileProps) => {
    if (onFileClick) {
      onFileClick(file);
      return;
    }

    if (file.type === 'document') {
      window.open(file.url, '_blank');
      return;
    }

    openModal(<PreviewModal url={file.url} isPdf={file.type === 'pdf'} name={file?.name} withControls />, {
      width: 'auto',
      noBackground: true,
      id: 'preview-modal',
    });
  };

  const handleFileDownload = async (file: FileProps) => {
    if (onFileDownload) {
      onFileDownload(file);
    } else {
      try {
        await download({
          name: file.name,
          uri: file.url,
          forceDownload: enableForceDownload,
        });
      } catch (e) {
        message.error('Não foi possível baixar o arquivo.');
      }
    }
  };

  if (loading) {
    return <EmptyList>Carregando arquivos...</EmptyList>;
  }

  return (
    <FilesListContainer>
      {files.length > 0 ? (
        files.map((file, index) => (
          <FileSingle
            key={`${file.name}-${index}`}
            {...file}
            onClick={() => handleFileClick(file)}
            onDownload={() => handleFileDownload(file)}
          />
        ))
      ) : (
        <EmptyList>
          <Alert label={emptyMessage} status="neutral" fullWidth />
        </EmptyList>
      )}
    </FilesListContainer>
  );
}
